/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourlistingandimageshavebeenuploadedsuccessfully7Inputs */

const en_yourlistingandimageshavebeenuploadedsuccessfully7 = /** @type {(inputs: Yourlistingandimageshavebeenuploadedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing and images have been uploaded successfully.`)
};

const de_yourlistingandimageshavebeenuploadedsuccessfully7 = /** @type {(inputs: Yourlistingandimageshavebeenuploadedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort und deine Bilder wurden hochgeladen.`)
};

/**
* | output |
* | --- |
* | "Your listing and images have been uploaded successfully." |
*
* @param {Yourlistingandimageshavebeenuploadedsuccessfully7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourlistingandimageshavebeenuploadedsuccessfully7 = /** @type {((inputs?: Yourlistingandimageshavebeenuploadedsuccessfully7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourlistingandimageshavebeenuploadedsuccessfully7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourlistingandimageshavebeenuploadedsuccessfully7(inputs)
	return de_yourlistingandimageshavebeenuploadedsuccessfully7(inputs)
});
export { yourlistingandimageshavebeenuploadedsuccessfully7 as "yourListingAndImagesHaveBeenUploadedSuccessfully" }